export class DeviceParamGatewayV3CronLirisData {
    public every: string = '8m';
    public enable: number = 1;
}
